export default __webpack_public_path__ + "3fd1c884b1cf1ceb0b181471fdfef44b.svg";